// src/pages/Setting.js
import React, { useEffect } from "react";
import { FaMoon, FaSun, FaUser, FaCog, FaShieldAlt } from "react-icons/fa";

function Settings({ darkMode, setDarkMode }) {
  useEffect(() => {
    if (!localStorage.getItem("auth")) window.location.href = "/login";
  }, []);

  return (
    <div className="p-6 max-w-screen-xl space-y-6">

      {/* Header */}
      <div>
        <h1 className="text-xl font-bold text-slate-900">Settings</h1>
        <p className="text-sm text-slate-500 mt-0.5">Manage your preferences and account</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-3xl">

        {/* Appearance */}
        <div className="card p-5 lg:col-span-3 space-y-4">
          <div className="flex items-center gap-2 mb-2">
            <FaCog className="text-slate-400 text-sm" />
            <span className="section-title">Appearance</span>
          </div>

          {/* Dark mode toggle */}
          <div className="flex items-center justify-between p-4 rounded-2xl bg-slate-50 border border-slate-100">
            <div className="flex items-center gap-3">
              <div className={`w-9 h-9 rounded-xl flex items-center justify-center
                ${darkMode ? "bg-slate-700 text-yellow-400" : "bg-slate-200 text-slate-500"}`}>
                {darkMode ? <FaMoon className="text-sm" /> : <FaSun className="text-sm" />}
              </div>
              <div>
                <div className="text-sm font-semibold text-slate-800">Dark Mode</div>
                <div className="text-xs text-slate-500">{darkMode ? "Dark theme active" : "Light theme active"}</div>
              </div>
            </div>
            <button
              onClick={() => setDarkMode(!darkMode)}
              aria-label="Toggle dark mode"
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300
                ${darkMode ? "bg-blue-600" : "bg-slate-200"}`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-300
                  ${darkMode ? "translate-x-6" : "translate-x-1"}`}
              />
            </button>
          </div>
        </div>

        {/* Account info */}
        <div className="card p-5 lg:col-span-3">
          <div className="flex items-center gap-2 mb-4">
            <FaUser className="text-slate-400 text-sm" />
            <span className="section-title">Account</span>
          </div>
          <div className="flex items-center gap-4 p-4 rounded-2xl bg-slate-50 border border-slate-100">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-500 to-violet-600
              flex items-center justify-center text-white font-bold text-lg shadow">
              M
            </div>
            <div>
              <div className="font-semibold text-slate-800">Malcolm</div>
              <div className="text-sm text-slate-500">Malcolm@gmail.com</div>
              <div className="mt-1">
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full
                  bg-blue-50 text-blue-600 border border-blue-100 text-xs font-medium">
                  Administrator
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Security */}
        <div className="card p-5 lg:col-span-3">
          <div className="flex items-center gap-2 mb-4">
            <FaShieldAlt className="text-slate-400 text-sm" />
            <span className="section-title">Security</span>
          </div>
          <div className="p-4 rounded-2xl bg-emerald-50 border border-emerald-100 flex items-center gap-3">
            <FaShieldAlt className="text-emerald-500" />
            <div className="text-sm text-emerald-700 font-medium">Session is active and secure</div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Settings;
